import { defineComponent as H, openBlock as t, createElementBlock as o, mergeProps as Z, unref as e, renderSlot as d, createElementVNode as n, createCommentVNode as V } from "vue";
import { useScalarIcon as i } from "../hooks/useScalarIcon.js";
const p = { key: 0 }, u = { key: 1 }, g = { key: 2 }, f = { key: 3 }, k = { key: 4 }, w = { key: 5 }, h = {
  name: "ScalarIconDiceTwo"
}, _ = /* @__PURE__ */ H({
  ...h,
  props: {
    label: {},
    weight: {}
  },
  setup(A) {
    const m = A, { bind: r, weight: l } = i(m);
    return (s, a) => (t(), o("svg", Z({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, e(r)), [
      d(s.$slots, "default"),
      e(l) === "bold" ? (t(), o("g", p, a[0] || (a[0] = [
        n("path", { d: "M192,28H64A36,36,0,0,0,28,64V192a36,36,0,0,0,36,36H192a36,36,0,0,0,36-36V64A36,36,0,0,0,192,28Zm12,164a12,12,0,0,1-12,12H64a12,12,0,0,1-12-12V64A12,12,0,0,1,64,52H192a12,12,0,0,1,12,12Zm-84-88a16,16,0,1,1-16-16A16,16,0,0,1,120,104Zm48,48a16,16,0,1,1-16-16A16,16,0,0,1,168,152Z" }, null, -1)
      ]))) : e(l) === "duotone" ? (t(), o("g", u, a[1] || (a[1] = [
        n("path", {
          d: "M216,64V192a24,24,0,0,1-24,24H64a24,24,0,0,1-24-24V64A24,24,0,0,1,64,40H192A24,24,0,0,1,216,64Z",
          opacity: "0.2"
        }, null, -1),
        n("path", { d: "M192,32H64A32,32,0,0,0,32,64V192a32,32,0,0,0,32,32H192a32,32,0,0,0,32-32V64A32,32,0,0,0,192,32Zm16,160a16,16,0,0,1-16,16H64a16,16,0,0,1-16-16V64A16,16,0,0,1,64,48H192a16,16,0,0,1,16,16Zm-88-84a12,12,0,1,1-12-12A12,12,0,0,1,120,108Zm40,40a12,12,0,1,1-12-12A12,12,0,0,1,160,148Z" }, null, -1)
      ]))) : e(l) === "fill" ? (t(), o("g", g, a[2] || (a[2] = [
        n("path", { d: "M192,32H64A32,32,0,0,0,32,64V192a32,32,0,0,0,32,32H192a32,32,0,0,0,32-32V64A32,32,0,0,0,192,32Zm-84,88a12,12,0,1,1,12-12A12,12,0,0,1,108,120Zm40,40a12,12,0,1,1,12-12A12,12,0,0,1,148,160Z" }, null, -1)
      ]))) : e(l) === "light" ? (t(), o("g", f, a[3] || (a[3] = [
        n("path", { d: "M192,34H64A30,30,0,0,0,34,64V192a30,30,0,0,0,30,30H192a30,30,0,0,0,30-30V64A30,30,0,0,0,192,34Zm18,158a18,18,0,0,1-18,18H64a18,18,0,0,1-18-18V64A18,18,0,0,1,64,46H192a18,18,0,0,1,18,18Zm-92-84a10,10,0,1,1-10-10A10,10,0,0,1,118,108Zm40,40a10,10,0,1,1-10-10A10,10,0,0,1,158,148Z" }, null, -1)
      ]))) : e(l) === "regular" ? (t(), o("g", k, a[4] || (a[4] = [
        n("path", { d: "M192,32H64A32,32,0,0,0,32,64V192a32,32,0,0,0,32,32H192a32,32,0,0,0,32-32V64A32,32,0,0,0,192,32Zm16,160a16,16,0,0,1-16,16H64a16,16,0,0,1-16-16V64A16,16,0,0,1,64,48H192a16,16,0,0,1,16,16Zm-88-84a12,12,0,1,1-12-12A12,12,0,0,1,120,108Zm40,40a12,12,0,1,1-12-12A12,12,0,0,1,160,148Z" }, null, -1)
      ]))) : e(l) === "thin" ? (t(), o("g", w, a[5] || (a[5] = [
        n("path", { d: "M192,36H64A28,28,0,0,0,36,64V192a28,28,0,0,0,28,28H192a28,28,0,0,0,28-28V64A28,28,0,0,0,192,36Zm20,156a20,20,0,0,1-20,20H64a20,20,0,0,1-20-20V64A20,20,0,0,1,64,44H192a20,20,0,0,1,20,20Zm-96-84a8,8,0,1,1-8-8A8,8,0,0,1,116,108Zm40,40a8,8,0,1,1-8-8A8,8,0,0,1,156,148Z" }, null, -1)
      ]))) : V("", !0)
    ], 16));
  }
});
export {
  _ as default
};
